/**
 * The Vendor Account a Vendor Portal file name names, for Pricing → Vendor Portals.
 *
 * The listing reads it in SQL with `substring(file name from pattern)`, binding this same
 * default pattern, so the upload dialog's prefill and the list agree. A vendor whose file
 * names carry the account elsewhere records its own pattern on its web_browser step; its
 * one capture group is the number (ABB's `^SPA-(\d+)-`). With no pattern, the digits that
 * end the name before the extension (`C351_00_84_PRICE_204079.xlsx` → `204079`).
 */
export const DEFAULT_VENDOR_ACCOUNT_FILE_NAME_PATTERN =
  "(\\d+)(?:\\.[A-Za-z0-9]+)?$";

/**
 * The account number `fileName` names, or null when the rule does not match. Like
 * Postgres's `substring(… from pattern)`: the first capture group, else the whole match.
 * A pattern JavaScript cannot compile falls back to the default rule.
 */
export function vendorAccountNumberFromFileName(
  fileName: string,
  pattern?: string | null,
): string | null {
  const match = compile(pattern)?.exec(fileName) ?? null;
  if (!match) return null;
  return (match.length > 1 ? match[1] : match[0]) || null;
}

function compile(pattern: string | null | undefined): RegExp | null {
  if (pattern) {
    try {
      return new RegExp(pattern);
    } catch {
      // Recorded patterns are validated when the step saves them; an old or hand-edited
      // one that does not compile here still leaves the default rule to prefill from.
    }
  }
  return new RegExp(DEFAULT_VENDOR_ACCOUNT_FILE_NAME_PATTERN);
}
